/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Edit_Is_HiddenInputs */

const en_forms_rule_sets_edit_is_hidden = /** @type {(inputs: Forms_Rule_Sets_Edit_Is_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Hidden`)
};

const de_forms_rule_sets_edit_is_hidden = /** @type {(inputs: Forms_Rule_Sets_Edit_Is_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ausgeblendet`)
};

/**
* | output |
* | --- |
* | "Is Hidden" |
*
* @param {Forms_Rule_Sets_Edit_Is_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_edit_is_hidden = /** @type {((inputs?: Forms_Rule_Sets_Edit_Is_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Edit_Is_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_edit_is_hidden(inputs)
	return de_forms_rule_sets_edit_is_hidden(inputs)
});